import 'jquery-menu-aim';

import $ from 'jquery';

function activateAimMenus($aimMenus) {
    $aimMenus.each(function () {
        $(this).menuAim({
            activate: function (item) {
                $(item).addClass('hovered');

                var targetSelector = $(item).data('target');

                if (targetSelector) {
                    var $target = $(targetSelector);
                    $target.removeClass('d-none');

                    $target.closest('.column').removeClass('d-none');
                }
            },
            deactivate: function (item) {
                $(item).removeClass('hovered');

                var targetSelector = $(item).data('target');

                if (targetSelector) {
                    var $target = $(targetSelector);
                    $target.addClass('d-none');

                    $target.closest('.column').addClass('d-none');
                }
            }
        });
    });
}

var $aimMenus = $('.aim-menu');
activateAimMenus($aimMenus);

function getServicesMenu() {
    var dfd = $.Deferred();

    var menu = null;

    var nowTs = new Date().getTime();

    try {
        var cacheTs = window.localStorage.getItem('services_menu_ts');

        if (cacheTs) {
            if (nowTs - parseInt(cacheTs) < 86400000) {
                var menuJson = window.localStorage.getItem('services_menu');

                if (menuJson) {
                    menu = JSON.parse(menuJson);
                    console.info('Menu extracted from localStorage');
                    dfd.resolve(menu);
                }
            }
        }
    } catch (e) {
        // localStorage unavailable
    }

    if (!menu) {
        $.ajax('/ajax/services_menu/', {
            method: 'GET'
        }).then(function (data) {
            try {
                window.localStorage.setItem('services_menu_ts', nowTs.toString());
                window.localStorage.setItem('services_menu', JSON.stringify(data));
            } catch (e) {
                // localStorage unavailable
            }

            dfd.resolve(data);
        }, function (reason) {
            dfd.reject(reason);
        });
    }

    return dfd.promise();
}

var $menuAnchor = $('#dropCategoriesDesktop');
var $menu = $('#menuServicesDesktop');
var menuInitialized = false;

$menuAnchor.on('mouseenter', function () {
    if (menuInitialized) {
        return true;
    }

    menuInitialized = true;

    getServicesMenu().then(function (data) {
        console.info('Populating the menu...');

        var $column = $menu.find('#menuServicesRight');
        $column.empty();

        var subcategories, $ul, $li, $a;

        for (var i = 0; i < data.length; i++) {
            subcategories = data[i]['children'] || [];

            $ul = $('<ul>', { id: 'category_menu_' + data[i]['id'] }).addClass('menu-items d-none');

            for (var j = 0; j < subcategories.length; j++) {
                $li = $('<li>').addClass('menu-item');
                $a = $('<a>', { href: subcategories[j].url }).text(subcategories[j].name);
                $li.append($a);
                $ul.append($li);
            }

            $column.append($ul);
        }
    }).then(function () {
        console.info('Activating the menu...');

        var $aimMenu = $menu.find('.menu-items').addClass('aim-menu');
        activateAimMenus($aimMenu);
    });
});
